<template>
  <TourSearchableList v-bind="$attrs" :options="props.options">
    <template #columns="{ tour }">
      <div class="tw:flex tw:items-center tw:gap-3 tw:px-2 tw:py-3 tw:shrink-0">
        <div v-if="!isNaN(tour.registrations_count)" class="tw:hidden tw:md:block tw:px-2 tw:text-center">
          <small class="tw:text-zinc-500 tw:uppercase tw:text-xs">{{ $t('Contacts') }}</small>
          <div class="tw:font-bold">{{ tour.registrations_count }}</div>
        </div>
        <div v-if="!isNaN(tour.product_tests_count)" class="tw:hidden tw:md:block tw:px-2 tw:text-center">
          <small class="tw:text-zinc-500 tw:uppercase tw:text-xs">{{ $t('Tests') }}</small>
          <div class="tw:font-bold">{{ tour.product_tests_count }}</div>
        </div>
        <DropdownMenu v-if="hasActions">
          <DropdownMenuTrigger as-child>
            <Button variant="outline">
              {{ $t('Actions') }}
              <ChevronDownIcon class="tw:ml-2 tw:size-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem v-if="actions.includes('duplicate')" as-child :disabled="!tour.has_permissions">
              <a :href="tour.links.duplicate">{{ $t('Duplicate') }}</a>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </template>
  </TourSearchableList>
</template>

<script setup>
import { computed } from 'vue'
import TourSearchableList from '@/components/Tour/TourSearchableList.vue'
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@/shadcn/components/ui/dropdown-menu'
import { Button } from '@/shadcn/components/ui/button'
import { ChevronDownIcon } from '@lucide/vue'

defineOptions({ inheritAttrs: false })

const supportedActions = ['duplicate']

const props = defineProps({
  actions: {
    type: Array,
    default: () => [],
  },
  options: {
    type: Object,
    default: () => ({}),
  },
})

const hasActions = computed(() => props.actions.some((action) => supportedActions.includes(action)))
</script>
